import { gql } from '@apollo/client'
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa'
import { ToastContent } from './Toast'
import {
  MutationResponseFragment,
  MutationResponseFragment_actions,
  MutationResponseFragment_actions_GenericMutationAction,
  MutationResponseFragment_actions_SendEmailMutationAction,
} from './__generated__/MutationResponseFragment'

export const mutationResponseFragment = gql`
  fragment MutationResponseFragment on MutationResponse {
    success
    message
    actions {
      success
      message

      ... on GenericMutationAction {
        description
      }

      ... on SendEmailMutationAction {
        email {
          id
          template
        }
      }
    }
  }
`

const getActionContent = (action: MutationResponseFragment_actions) => {
  const genericAction = action as MutationResponseFragment_actions_GenericMutationAction
  if (genericAction.description) {
    return (
      <>
        {genericAction.description} {genericAction.message && <>({genericAction.message})</>}
      </>
    )
  }

  const sendEmailAction = action as MutationResponseFragment_actions_SendEmailMutationAction
  if (sendEmailAction.email) {
    return <>Send email: {sendEmailAction.email.template}</>
  }

  return <>{JSON.stringify(action)}</>
}

const ActionSummary = ({ response }: { response: MutationResponseFragment }) => (
  <>
    <ul>
      {response.actions.map((action, i) => (
        <li key={i} className="is-flex is-align-items-center">
          {action.success ? <FaCheckCircle className="mr-3" /> : <FaExclamationCircle className="mr-3" />}
          <div>{getActionContent(action)}</div>
        </li>
      ))}
    </ul>
  </>
)

const mutationResponseToToast = (response: MutationResponseFragment): ToastContent => {
  return {
    messageType: 'success',
    title: 'Success',
    content: <ActionSummary response={response} />,
    timeout: 10000,
  }
}

export default mutationResponseToToast
